import type { InputHTMLAttributes } from 'react';

interface FieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
}

export default function Field({ label, error, id, name, ...rest }: FieldProps) {
  const inputId = id ?? name;
  return (
    <label className="block" htmlFor={inputId}>
      <span className="mb-1 block text-sm font-medium text-[var(--cad-text-muted,#d4d4d8)]">{label}</span>
      <input
        id={inputId}
        name={name}
        aria-invalid={error ? true : undefined}
        className="w-full rounded-md border border-[var(--cad-panel-border,#3f3f46)] bg-[var(--cad-panel-bg,#18181b)] px-3 py-2 text-sm text-[var(--cad-text,#f4f4f5)] outline-none focus:border-[var(--cad-accent,#6366f1)]"
        {...rest}
      />
      {error ? <span className="mt-1 block text-xs text-[var(--cad-danger,#f87171)]">{error}</span> : null}
    </label>
  );
}
